<template>
  <div style="background: #f8fafc">
    <div class="lc-achievement-box">
      <strong>联创成果</strong>
      <p>
        各类数智转型的场景案例示范
        <span @click="$router.push('/result')">查看全部 ></span>
      </p>
      <div class="lc-achievement-list-box">
        <div v-for="el in resultList" :key="el.id" class="lc-achievement-list">
          <v-img
            :attachment-id="el.coverAttmId"
            :default-img="require('@/assets/img/cmrt.png')"
          />
          <div>
            <span>{{ el.acvName }}</span>
            <p v-html="el.content"></p>
            <a-button
              class="btn-red"
              @click="$router.push(`/result/info?id=${el.id}`)"
              >查看详情</a-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VImg from "@/components/VImg";
import { getAchievementList } from "@/api/achievement";
export default {
  components: {
    VImg,
  },
  data() {
    return {
      resultList: [],
    };
  },
  mounted() {
    this.loadGetAchievementList();
  },
  methods: {
    loadGetAchievementList() {
      getAchievementList(
        {
          current: 1,
          size: 6,
        },
        {}
      ).then((res) => {
        this.resultList = res.records;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.lc-achievement-box {
  padding: 64px 0;
  width: 1280px;
  margin: 0 auto;
  > strong {
    display: block;
    font-size: 32px;
    line-height: 45px;
    color: #262626;
    text-align: center;
    margin-bottom: 16px;
  }
  > p {
    font-size: 18px;
    line-height: 24px;
    color: #000;
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    > span {
      color: #ea0b06;
      margin-left: 12px;
      line-height: 24px;
      cursor: pointer;
    }
  }
  .lc-achievement-list-box {
    display: flex;
    flex-wrap: wrap;
    .lc-achievement-list {
      width: 410px;
      height: 396px;
      margin-right: 25px;
      margin-top: 24px;
      background: #fff;
      cursor: pointer;
      overflow: hidden;
      transition: all 0.3s;
      &:nth-child(3n) {
        margin-right: 0;
      }
      > img {
        display: block;
        width: 100%;
        height: 244px;
      }
      > div {
        background: #fff;
        padding: 24px;
        transition: all 0.3s;
        position: relative;
        top: 0;
        z-index: 2;
        > span {
          display: block;
          font-weight: bold;
          font-size: 20px;
          color: rgba(0, 0, 0, 0.85);
          line-height: 28px;
          margin-bottom: 16px;
        }
        > p {
          font-size: 14px;
          color: #666666;
          line-height: 20px;
          height: 60px;
          overflow: hidden;
        }
        > button {
          opacity: 0;
          margin-top: 40px;
          width: 100%;
        }
      }
      &:hover {
        box-shadow: 0px 4px 13px 0px rgba(195, 195, 195, 0.3);
        > div {
          top: -72px;
          > button {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
